import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { CardContent as CardContent$2, CardContentUpper, CardContentLower } from './CardContent.style.js';
import Ratings from './Ratings.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useIsGlobetrotter from '../../../hooks/useIsGlobetrotter.js';
import Tags from './Tags.js';
import Title from './Title.js';
import Subtitle from './Subtitle.js';
import Paragraph from './Paragraph.js';
import Bullets from './Bullets.js';
import Ksps from './Ksps.js';
import IncludedProducts from './IncludedProducts.js';
import LinkList from './LinkList.js';
import PromotionBadge from '../../PromotionBadge/PromotionBadge.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CardContent = function CardContent(_ref) {
  var _ref$tags = _ref.tags,
    tags = _ref$tags === void 0 ? null : _ref$tags,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$headingLevel = _ref.headingLevel,
    headingLevel = _ref$headingLevel === void 0 ? null : _ref$headingLevel,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? null : _ref$subtitle,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? null : _ref$description,
    _ref$rating = _ref.rating,
    rating = _ref$rating === void 0 ? null : _ref$rating,
    _ref$ratingPrefix = _ref.ratingPrefix,
    ratingPrefix = _ref$ratingPrefix === void 0 ? null : _ref$ratingPrefix,
    _ref$tripadvisorRatin = _ref.tripadvisorRating,
    tripadvisorRating = _ref$tripadvisorRatin === void 0 ? null : _ref$tripadvisorRatin,
    _ref$guestRating = _ref.guestRating,
    guestRating = _ref$guestRating === void 0 ? null : _ref$guestRating,
    _ref$bullets = _ref.bullets,
    bullets = _ref$bullets === void 0 ? null : _ref$bullets,
    _ref$ksps = _ref.ksps,
    ksps = _ref$ksps === void 0 ? null : _ref$ksps,
    cardSettings = _ref.cardSettings,
    _ref$includedProducts = _ref.includedProducts,
    includedProducts = _ref$includedProducts === void 0 ? null : _ref$includedProducts,
    _ref$includedProducts2 = _ref.includedProductsTitle,
    includedProductsTitle = _ref$includedProducts2 === void 0 ? null : _ref$includedProducts2,
    _ref$linkList = _ref.linkList,
    linkList = _ref$linkList === void 0 ? null : _ref$linkList,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? null : _ref$url,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$onClickElementPr = _ref.onClickElementProps,
    onClickElementProps = _ref$onClickElementPr === void 0 ? null : _ref$onClickElementPr,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$promotionLabel = _ref.promotionLabel,
    promotionLabel = _ref$promotionLabel === void 0 ? null : _ref$promotionLabel;
  var isGlobetrotter = useIsGlobetrotter();
  var hasNoRatings = !rating && !tripadvisorRating && !guestRating;
  return /*#__PURE__*/jsxs(CardContent$2, _objectSpread(_objectSpread({}, cardSettings), {}, {
    children: [/*#__PURE__*/jsxs(CardContentUpper, _objectSpread(_objectSpread({}, cardSettings), {}, {
      children: [!!(tags !== null && tags !== void 0 && tags.length) && /*#__PURE__*/jsx(Tags, {
        tags: tags
      }), title && /*#__PURE__*/jsx(Title, {
        className: "uikit-card-content-title",
        onClick: onClick,
        titleLinkProps: onClickElementProps,
        url: url,
        headingLevel: headingLevel,
        children: title
      }), subtitle && /*#__PURE__*/jsx(Subtitle, {
        children: subtitle
      }), !hasNoRatings && /*#__PURE__*/jsx(Ratings, {
        rating: rating,
        ratingPrefix: ratingPrefix,
        guestRating: guestRating,
        tripadvisorRating: tripadvisorRating
      })]
    })), /*#__PURE__*/jsxs(CardContentLower, _objectSpread(_objectSpread({}, cardSettings), {}, {
      children: [!!description && /*#__PURE__*/jsx(Paragraph, {
        children: description
      }), !!(bullets !== null && bullets !== void 0 && bullets.length) && /*#__PURE__*/jsx(Bullets, {
        items: bullets
      }), !!(ksps !== null && ksps !== void 0 && ksps.length) && /*#__PURE__*/jsx(Ksps, {
        items: ksps
      }), !!(includedProducts !== null && includedProducts !== void 0 && includedProducts.length) && /*#__PURE__*/jsx(IncludedProducts, {
        title: includedProductsTitle,
        products: includedProducts
      }), !!(linkList !== null && linkList !== void 0 && linkList.length) && /*#__PURE__*/jsx(LinkList, {
        cardSettings: cardSettings,
        links: linkList,
        title: title
      }), children, !isGlobetrotter && (promotionLabel === null || promotionLabel === void 0 ? void 0 : promotionLabel.text) && (promotionLabel === null || promotionLabel === void 0 ? void 0 : promotionLabel.urgency) && (promotionLabel === null || promotionLabel === void 0 ? void 0 : promotionLabel.type) && /*#__PURE__*/jsx(PromotionBadge, {
        className: "uikit-card-promotion-badge",
        promotion: promotionLabel === null || promotionLabel === void 0 ? void 0 : promotionLabel.text,
        type: promotionLabel === null || promotionLabel === void 0 ? void 0 : promotionLabel.type,
        urgency: promotionLabel === null || promotionLabel === void 0 ? void 0 : promotionLabel.urgency
      })]
    }))]
  }));
};
var CardContent$1 = CardContent;

export { CardContent$1 as default };
//# sourceMappingURL=CardContent.js.map
